export default __webpack_public_path__ + "static/analysts_Architect_INTJ_personality_header-7ae361e9f071cffffb21a9785e5bfb16.svg";